module.exports = __webpack_public_path__ + "img/WeekDays.0baa2d67.svg";